import React, {Component} from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Grid} from '@material-ui/core'
import styles from './styles'
import {contentData} from './content'
import AddInsuranceCarrierCard from './AddInsuranceCarrierCard/AddPublicInsuranceCard'
import BasicView from '../../../../components/Layouts/BasicView/BasicView'


import {request_add_insurance_carrier} from './requests'

class AddInsuranceCarrier extends Component{

  state = {
    isloading:false,
    issending:false,
    error:null,
    user:null,
    success:{open:false,timeout:2000,type:'success',message:'¡Acción exitosa!'},
  }

  componentDidMount(){
    this.initModule()
  }

  onCloseSnackbar = (id) => {
    let temp = this.state[id];
    temp.open = false;
    this.setState({[id]:{...temp}})
  }

  onActivateSuccessSnack = () => {
    const {success} = this.state;
    let success_temp = {...success};
    success_temp.open = true;
    this.setState({success:{...success_temp}})
  }

  initModule = async() => {
    this.setState({isloading:true})

    this.setState({isloading:false})
  }

  onCreateItem = async(data) => {
    
    try {
      this.setState({issending:true})
      let id = await request_add_insurance_carrier(data)
      this.setState({issending:false, error:null})
      this.props.history.push("/catalogs/insurance_carriers/"+id)
    } catch (error) {
      this.setState({issending:false})
      if(error.response){
        this.setState({error:error.response.data.error.message})
      }
      
    }
  }

  render(){

    const { history, language, catalogs,translations} = this.props;
    const {isloading, issending, error, success} = this.state
    const content = contentData[language]
    
    return(
      <BasicView
        isloading={isloading}
        history={history}
        selected={0}
        onChange={this.onChangeView}
        content={content.layout}
        success={success}
        onCloseSnackbar={this.onCloseSnackbar}
        returnBtn={true}
        onReturn={this.onReturn}
      >
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <AddInsuranceCarrierCard 
              language={language}
              catalogs={catalogs}
              translations={translations}
              issending={issending}
              error={error}
              onSubmit={this.onCreateItem}
              />
          </Grid>
        </Grid>
      </BasicView>
      
    )
  }

  onReturn = () => {
    this.props.history.goBack()
  }

}

export default withStyles(styles)(AddInsuranceCarrier)